// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"a98feffd","277":"bd6fc4b8","453":"64be9eb2","895":"d793ef71","945":"0cff1ef6"}[chunkId] + ".chunk.js";
};